import "./App.css";
import { Header } from "../components/Header/Header";
import { PageRouting } from "./PageRouting/PageRouting";
import { Footer } from "../components/Footer/Footer";

function App() {
  return (
    <>
      <Header />
      <PageRouting />
      <Footer />
    </>
  );
}

export default App;
